import Vue from 'vue';
import moment from 'moment';
import { find } from 'lodash';

export default {
  setToken(state, token) {
    Vue.set(state.auth, 'token', token);
  },

  setDeviceDetails(state, details) {
    Vue.set(state, 'device', details);
  },

  setBookings(state, bookings) {
    Vue.set(state, 'bookings', bookings);
  },

  setSpace(state, space) {
    Vue.set(state, 'space', space);
  },

  setSpaces(state, spaces) {
    Vue.set(state, 'spaces', spaces);
  },

  setHourToDisplay(state, hour) {
    Vue.set(state.cards, 'goTo', hour);
  },

  setPin(state, pin) {
    Vue.set(state.auth, 'pin', pin);
  },

  setPinCountDown(state, shouldStart) {
    Vue.set(state, 'startPinCountDown', shouldStart);
  },

  updateBooking(state, { data, bookingId }) {
    const booking = find(state.bookings, b => b.id === bookingId);
    Object.assign(booking, data);
  },

  setCapAlertURLs(state, urls) {
    Vue.set(state, 'capAlertURLs', urls);
  },

  setDate(state, date) {
    Vue.set(state, 'selectedDate', moment(date));
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js